import { render } from "./FeeView.vue?vue&type=template&id=7c7264bd"
import script from "./FeeView.vue?vue&type=script&lang=js"
export * from "./FeeView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__